export default __webpack_public_path__ + "static/media/11.33cfc6bb.jpg";